<template>
  <div class="popup dialog">
    <h4 v-if="popupData.title.length > 0">{{popupData.title}}</h4>
    <p class="text">{{popupData.content}}</p>
    <div class="btnWrap fbbWrap">
      <span
        v-for="(item, index) in popupData.button"
        class="confirm"
        :class="{fbb: index === 0}"
        :key="item.id"
        @click="item.onClick"
      >
        {{item.text}}
      </span>
    </div>
    <div @click="close" class="close fbbClose">
      <i class="iconfont icon-close"></i>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Dialog',
  props: {
    popupData: {
      type: Object,
    },
  },
  methods: {
    close() {
      this.$bus.$emit('hidePopup');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/popup/FbbDialog.vue